import { defineMessages } from 'react-intl';

export default defineMessages({
  '1': {
    'id': '1',
    'defaultMessage': "January"
  },
  '2': {
    'id': '2',
    'defaultMessage': "February"
  },
  '3': {
    'id': '3',
    'defaultMessage': "March"
  },
  '4': {
    'id': '4',
    'defaultMessage': "April"
  },
  '5': {
    'id': '5',
    'defaultMessage': "May"
  },
  '6': {
    'id': '6',
    'defaultMessage': "June"
  },
  '7': {
    'id': '7',
    'defaultMessage': "July"
  },
  '8': {
    'id': '8',
    'defaultMessage': "August"
  },
  '9': {
    'id': '9',
    'defaultMessage': "September"
  },
  '10': {
    'id': '10',
    'defaultMessage': "October"
  },
  '11': {
    'id': '11',
    'defaultMessage': "November"
  },
  '12': {
    'id': '12',
    'defaultMessage': "December"
  }
});